var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PdfJs, { PdfJsWorkerSrc, CMAP_URL, CMAP_PACKED } from "./PdfJs/ImportPdfJs";
import { MappingStorage } from "../mapper";
import { sleep, uuidv4 } from "../util";
import { NeoPdfPage } from "./NeoPdfPage";
// console.log(`PDFjs version=${PdfJs.version}`);
// PdfJs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJs.version}/pdf.worker.js`;
// PdfJs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJs.version}/pdf.worker.min.js`;
PdfJs.GlobalWorkerOptions.workerSrc = PdfJsWorkerSrc;
export class NeoPdfDocument {
    get title() {
        return this._title;
    }
    constructor() {
        // TODO: URL이 있는지 점검하는 루틴이 제대로 동작하지 않아서, 일단은 모두 true를 리턴하도록, 나중에 수정해야 한다
        this.UrlExists = (url) => {
            const blobTest = /^blob:/;
            const dataTest = /^data:/;
            if (blobTest.test(url) || dataTest.test(url)) {
                return true;
            }
            return true;
            // const http = new XMLHttpRequest();
            // http.open('HEAD', url, false);
            // http.send();
            // return http.status != 404;
        };
        this.load = (options) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            // console.log(`~PDF LOADER~,   load, step 1, URL=${options.url}`);
            if (!this.UrlExists(options.url)) {
                return undefined;
            }
            let pdfDoc = null;
            let retryCount = 15;
            while (!pdfDoc && retryCount > 0) {
                pdfDoc = yield pdfJsOpenDocument(options);
                yield sleep(100);
                retryCount--;
            }
            // if (!pdfDoc) {
            //   throw new Error("#40001 Network Error PDF");
            // }
            // console.log("~PDF LOADER~,   load, step 2")
            // page를 로드한다
            if (pdfDoc) {
                const { url, filename, purpose } = options;
                this._url = url;
                this._filename = filename;
                this._purpose = purpose;
                this._fingerprint = ((_a = pdfDoc.fingerprints) === null || _a === void 0 ? void 0 : _a[0]) || pdfDoc.fingerprint;
                this._numPages = pdfDoc.numPages;
                this._pdfDoc = pdfDoc;
                // _doc_fingerprint = pdfDoc.fingerprint;
                this._pages = [];
                for (let i = 0; i < this._pdfDoc.numPages; i++) {
                    // const page = await pdf.getPageAsync(i + 1);
                    const neoPage = new NeoPdfPage(this, i + 1);
                    this._pages.push(neoPage);
                }
                yield this.setPageOverview();
                return this;
            }
            return undefined;
        });
        this.destroy = () => {
            this._pages = [];
            this._pdfDoc.destroy();
        };
        this.getPageAsync = (pageNum) => __awaiter(this, void 0, void 0, function* () {
            // 예전의 돌려쓰기 PDF의 경우
            if (pageNum > this._numPages) {
                console.log(`이전 버전의 반복 페이지 PDF 기술을 썼던, PDF, 총 페이지 ${this._numPages} 보다 큰 페이지 ${pageNum}를 요구`);
                pageNum = ((pageNum - 1) % this._numPages) + 1;
            }
            yield this._pages[pageNum - 1]._ready;
            return this._pages[pageNum - 1];
        });
        /**
         * pageNum은 1부터 시작, pageNum이라고 된 것은 모두 1부터 시작하는 것으로 통일
         * page가 로드된 것이 확실할 때만 쓸 것!
         *
         * @param {number} pageNum
         * @memberof NeoPdfDocument
         */
        this.getPage = (pageNum) => {
            if (pageNum > this._numPages) {
                console.error(`예전에 씌였던 돌려쓰기 PDF, 총 페이지 ${this._numPages} 보다 큰 페이지 ${pageNum}를 요구`);
                pageNum = ((pageNum - 1) % this._numPages) + 1;
            }
            if (!this._pages[pageNum - 1]._loaded) {
                throw new Error(`PDF page ${pageNum} has not been loaded`);
            }
            return this._pages[pageNum - 1];
        };
        this.getMetadata = () => __awaiter(this, void 0, void 0, function* () {
            return this._pdfDoc.getMetadata();
        });
        this.getPageSize = (pageNum) => {
            if (pageNum > this.numPages) {
                return undefined;
            }
            // return {width:595, height:841};
            return this._pagesOverview[pageNum - 1].sizePu;
        };
        // 2021/08/04
        this.setPageOverview = () => __awaiter(this, void 0, void 0, function* () {
            this._pagesOverview = new Array(this.numPages);
            let numPortraitPages = 0;
            let numLandscapePages = 0;
            const promises = [];
            for (let i = 0; i < this.numPages; i++) {
                promises.push(this._pages[i]._ready);
            }
            yield Promise.all(promises);
            for (let i = 0; i < this.numPages; i++) {
                const page = this._pages[i];
                const vpt = page.viewport;
                const { width, height } = vpt;
                const landscape = width > height;
                landscape ? numLandscapePages++ : numPortraitPages++;
                const pageOverview = {
                    rotation: vpt.rotation,
                    landscape,
                    sizePu: { width, height },
                };
                this._pagesOverview[i] = pageOverview;
            }
            if (numPortraitPages >= numLandscapePages) {
                this.direction = "portrait";
            }
            else {
                this.direction = "landscape";
            }
            return this.direction;
        });
        this.setPageOverview_old = () => __awaiter(this, void 0, void 0, function* () {
            this._pagesOverview = new Array(this.numPages);
            let numPortraitPages = 0;
            let numLandscapePages = 0;
            for (let i = 0; i < this.numPages; i++) {
                const page = yield this._pdfDoc.getPage(i + 1);
                const vpt = page.getViewport({ scale: 1, rotation: page.rotate });
                const { width, height } = vpt;
                const landscape = width > height;
                landscape ? numLandscapePages++ : numPortraitPages++;
                const pageOverview = {
                    rotation: vpt.rotation,
                    landscape,
                    sizePu: { width, height },
                };
                this._pagesOverview[i] = pageOverview;
            }
            if (numPortraitPages >= numLandscapePages) {
                this.direction = "portrait";
            }
            else {
                this.direction = "landscape";
            }
            return this.direction;
        });
        this.setNcodeAssigned = (pdfToNcodeMap) => {
            this._ncodeAssigned = MappingStorage.makeAssignedNcodeArray(pdfToNcodeMap.printPageInfo, this.numPages);
        };
        this.getPageNcode = (pageNum) => {
            if (!pageNum || pageNum < 1 || pageNum > this.numPages) {
                throw new Error("Page number range error");
            }
            return this._ncodeAssigned[pageNum - 1];
        };
        this._uuid = uuidv4();
        // console.log(`:PDF LOADER:,     constructor()`);
    }
    get numPages() { return this._numPages; }
    get url() { return this._url; }
    get filename() { return this._filename; }
    get fingerprint() {
        return this._fingerprint;
        // return this._pdfDoc.fingerprints?.[0] || (this._pdfDoc as any).fingerprint;
    }
    get purpose() { return this._purpose; }
    // public getPageThumbnailUrl = async (
    //   pageNum: number, width: number, height: number,
    //   bgColor = "rgba(255,255,255,0)", drawCalibrationMark = false, markPos = 2) => {
    //   if (pageNum < 1 || pageNum > this.numPages) {
    //     console.error(`getPageThumbnailUrl failed, page number is ${pageNum} of total pages(${this.numPages})`);
    //     return NeoPdfPage.getDummyThumbnail();
    //   }
    //   const neoPage = await this.getPageAsync(pageNum);
    //   return neoPage.getThumbnailUrl(width, height, bgColor, drawCalibrationMark, markPos);
    // }
    // public generatePageThumbnails = async (width: number, height: number, bgColor: string, drawCalibrationMark: boolean) => {
    //   const numPages = this.numPages;
    //   for (let i = 1; i <= (numPages > 1 ? 2 : 1); i++) {
    //     await this.getPageThumbnailUrl(i, width, height, bgColor, drawCalibrationMark);
    //   }
    // }
    get id() {
        return this._id;
    }
    get pagesOverview() {
        return this._pagesOverview;
    }
}
const max_concurrent = 16;
let pdf_loader_idx = 0;
const pdf_fingerprint = new Array(16);
function gridaJsOpenDocument(options, _gridaRawData, _neoStroke) {
    const { url, cMapUrl, cMapPacked } = options;
    pdf_loader_idx = (pdf_loader_idx + 1) % max_concurrent;
    pdf_fingerprint[pdf_loader_idx] = "";
    console.log(":PDF LOADER:,     gridaJsOpenDocument, step 1");
    const docInitParams = {
        data: _gridaRawData,
        neostroke: _neoStroke,
        url: url,
        cMapUrl: cMapUrl ? cMapUrl : CMAP_URL,
        cMapPacked: cMapPacked ? cMapPacked : CMAP_PACKED,
    };
    return new Promise(resolve => {
        PdfJs.getDocument(docInitParams).promise.then(function (pdf) {
            var _a;
            resolve(pdf);
            pdf_fingerprint[pdf_loader_idx] = ((_a = pdf.fingerprints) === null || _a === void 0 ? void 0 : _a[0]) || pdf.fingerprint;
        });
    });
}
function pdfJsOpenDocument(options) {
    const { url, cMapUrl, cMapPacked } = options;
    const AuthTokenStorageKey = '__OTL_Authentication_Token__';
    const token = sessionStorage.getItem(AuthTokenStorageKey);
    pdf_loader_idx = (pdf_loader_idx + 1) % max_concurrent;
    pdf_fingerprint[pdf_loader_idx] = "";
    // console.log(":PDF LOADER:,     pdfJsOpenDocument, step 1")
    const openOption = {
        url: url,
        cMapUrl: cMapUrl ? cMapUrl : CMAP_URL,
        cMapPacked: cMapPacked ? cMapPacked : CMAP_PACKED,
        httpHeaders: { 'X-Auth-Token': token },
    };
    // console.log(`:PDF LOADER:,     pdfJsOpenDocument, step 2  fingerprint=${pdf_fingerprint} `);
    const loadingTask = PdfJs.getDocument(openOption);
    /**
     * 왜, 아래의 부분의 await 다음이 두번 콜백 실행되지? callback에 등록이 희안하게 되는 모양인데 말이지.
     * 마치 thread가 나뉘어 진 것 같이 동작한다.
     * NeoPdfDocument도 객체가 두번 생긴다. 이건 버그가 아닌가 싶은데 말이지?
     *
     * 2020/12/27, kitty
     */
    // // eslint-disable-next-line no-constant-condition
    // if (1 === 0) {
    //   const pdfDoc = await loadingTask.promise;
    //   console.log(`:PDF LOADER:,     pdfJsOpenDocument, step 3  fingerprint=${pdf_fingerprint} `);
    //   pdf_fingerprint = pdfDoc.fingerprint;
    //   return pdfDoc;
    // }
    /**
     * 아래는 임시 방편으로 하나만 리턴하도록 했다. 즉, 꼼수다.
     * 2020/12/27, kitty
     */
    // return new Promise(  (resolve) => {
    //   loadingTask.promise.then(pdf => {
    //     console.log(pdf);
    //     resolve(pdf);
    //     // if (pdf_fingerprint[pdf_loader_idx] === "" || pdf_fingerprint[pdf_loader_idx] !== pdf.fingerprint) {
    //     //   resolve(pdf);
    //     // }
    //     // else {
    //     //   pdf.destroy();
    //     // }
    //     console.log(`:PDF LOADER:,     pdfJsOpenDocument, step 3  fingerprint=${pdf_fingerprint} `);
    //     pdf_fingerprint[pdf_loader_idx] = pdf.fingerprint;
    //   });
    // })
    /**
     * then catch가 안 먹어서 await를 내부에 썼다.
     * 2020/12/27, kitty
     */
    return new Promise((resolve, reject) => {
        try {
            loadingTask.promise.then((pdf) => {
                var _a;
                pdf_fingerprint[pdf_loader_idx] = ((_a = pdf.fingerprints) === null || _a === void 0 ? void 0 : _a[0]) || pdf.fingerprint;
                resolve(pdf);
            });
        }
        catch (e) {
            reject(new Error("loading Failed"));
        }
    });
}
//# sourceMappingURL=NeoPdfDocument.js.map